import { apiFetch } from "./client";

export interface AssistantMessage {
  id: string;
  role: "user" | "assistant";
  content: string;
  metadata?: {
    toolSteps?: Array<{ id: string; name: string; status: string; durationMs?: number }>;
    guideOffers?: Array<{ guideId: string; title: string }>;
  } | null;
  createdAt: string;
}

export interface AssistantSessionResponse {
  session: { id: string; title: string };
  messages: AssistantMessage[];
  assistantName?: string;
}

/** Page context the widget reports so Scout can auto-scope "this agent/workflow". */
export interface AssistantPageContext {
  path?: string;
  agentId?: string;
  workflowId?: string;
  runId?: string;
}

export const assistantApi = {
  getSession: (companyId: string) =>
    apiFetch<AssistantSessionResponse>(`/companies/${companyId}/assistant/session`),
  resetSession: (companyId: string) =>
    apiFetch<AssistantSessionResponse>(`/companies/${companyId}/assistant/session/reset`, {
      method: "POST",
    }),
};
